// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Ascend token bridge ─────────────────────────────────────────────────────
   Semantic tokens aliased to their Ascend equivalents so components using
   either system resolve to the same design values. Requires ascend-tokens.css
   to be loaded first (it defines the var(--*) sources referenced here). */
:root {
  /* Ascend-bridged tokens (override prim-color defaults where applicable) */
  --color-bg-primary:     var(--white);
  --color-bg-secondary:   var(--prim-color-grey-50);
  --color-bg-surface:     var(--surface);
  --color-text-primary:   var(--jet);
  --color-text-secondary: var(--cg-11);
  --color-text-inverse:   var(--prim-color-white);
  --color-border:         var(--cg-2);
  --color-accent:         var(--accessible-blue);
  --color-accent-hover:   var(--prim-color-blue-600);
  --color-status-success: var(--success-green);
  --color-status-warning: var(--orange);
  --color-status-error:   var(--red);
  --color-domain-benchmarking: #7c3aed;
  --color-domain-financial:    #2563eb;
  --color-domain-clustering:   #059669;
  --shadow-card:   var(--prim-shadow-sm);
  --shadow-nav:    var(--prim-shadow-md);
  --shadow-topbar: 0 2px 4px rgba(0,0,0,0.08);
  --nav-width:           260px;
  --nav-width-collapsed:  60px;
  --topbar-height:        56px;
}

@media (prefers-color-scheme: dark) {
  ::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }
  ::-webkit-scrollbar-track {
    background: #1A1A1A;
  }
  ::-webkit-scrollbar-thumb {
    background: #3A3A38;
    border-radius: 4px;
  }
  ::-webkit-scrollbar-thumb:hover {
    background: #75787B;
  }
  * {
    scrollbar-color: #3A3A38 #1A1A1A;
    scrollbar-width: thin;
  }
}

html.dark-mode ::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}
html.dark-mode ::-webkit-scrollbar-track {
  background: #1A1A1A;
}
html.dark-mode ::-webkit-scrollbar-thumb {
  background: #3A3A38;
  border-radius: 4px;
}
html.dark-mode ::-webkit-scrollbar-thumb:hover {
  background: #75787B;
}
html.dark-mode * {
  scrollbar-color: #3A3A38 #1A1A1A;
  scrollbar-width: thin;
}

/* ── Global cursor reset ─────────────────────────────────────────────────────
   !important is required here because emotion injects styled-component class
   rules AFTER this static file loads, and equal-or-higher specificity class
   rules would otherwise override * without !important. */
* {
  cursor: default !important;
}

a,
button,
select,
label,
summary,
[role="button"],
[role="tab"],
[role="menuitem"],
[role="option"],
[role="checkbox"],
[role="radio"],
[role="switch"] {
  cursor: pointer !important;
}

input,
textarea,
[contenteditable="true"] {
  cursor: text !important;
}

/* cursor: not-allowed on disabled interactive elements */
:disabled,
[aria-disabled="true"] {
  cursor: not-allowed !important;
}

.ProseMirror[contenteditable="false"] {
  cursor: default !important;
  user-select: none;
}
`, "",{"version":3,"sources":["webpack://./tokens/semantic.css"],"names":[],"mappings":"AAAA;;;0EAG0E;AAC1E;EACE,0EAA0E;EAC1E,oCAAoC;EACpC,iDAAiD;EACjD,sCAAsC;EACtC,kCAAkC;EAClC,oCAAoC;EACpC,+CAA+C;EAC/C,mCAAmC;EACnC,8CAA8C;EAC9C,kDAAkD;EAClD,4CAA4C;EAC5C,qCAAqC;EACrC,kCAAkC;EAClC,oCAAoC;EACpC,oCAAoC;EACpC,oCAAoC;EACpC,sCAAsC;EACtC,sCAAsC;EACtC,2CAA2C;EAC3C,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA;EACE;IACE,UAAU;IACV,WAAW;EACb;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;IACnB,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,gCAAgC;IAChC,qBAAqB;EACvB;AACF;;AAEA;EACE,UAAU;EACV,WAAW;AACb;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gCAAgC;EAChC,qBAAqB;AACvB;;AAEA;;;yDAGyD;AACzD;EACE,0BAA0B;AAC5B;;AAEA;;;;;;;;;;;;EAYE,0BAA0B;AAC5B;;AAEA;;;EAGE,uBAAuB;AACzB;;AAEA,yDAAyD;AACzD;;EAEE,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;EAC1B,iBAAiB;AACnB","sourcesContent":["/* ── Ascend token bridge ─────────────────────────────────────────────────────\n   Semantic tokens aliased to their Ascend equivalents so components using\n   either system resolve to the same design values. Requires ascend-tokens.css\n   to be loaded first (it defines the var(--*) sources referenced here). */\n:root {\n  /* Ascend-bridged tokens (override prim-color defaults where applicable) */\n  --color-bg-primary:     var(--white);\n  --color-bg-secondary:   var(--prim-color-grey-50);\n  --color-bg-surface:     var(--surface);\n  --color-text-primary:   var(--jet);\n  --color-text-secondary: var(--cg-11);\n  --color-text-inverse:   var(--prim-color-white);\n  --color-border:         var(--cg-2);\n  --color-accent:         var(--accessible-blue);\n  --color-accent-hover:   var(--prim-color-blue-600);\n  --color-status-success: var(--success-green);\n  --color-status-warning: var(--orange);\n  --color-status-error:   var(--red);\n  --color-domain-benchmarking: #7c3aed;\n  --color-domain-financial:    #2563eb;\n  --color-domain-clustering:   #059669;\n  --shadow-card:   var(--prim-shadow-sm);\n  --shadow-nav:    var(--prim-shadow-md);\n  --shadow-topbar: 0 2px 4px rgba(0,0,0,0.08);\n  --nav-width:           260px;\n  --nav-width-collapsed:  60px;\n  --topbar-height:        56px;\n}\n\n@media (prefers-color-scheme: dark) {\n  ::-webkit-scrollbar {\n    width: 8px;\n    height: 8px;\n  }\n  ::-webkit-scrollbar-track {\n    background: #1A1A1A;\n  }\n  ::-webkit-scrollbar-thumb {\n    background: #3A3A38;\n    border-radius: 4px;\n  }\n  ::-webkit-scrollbar-thumb:hover {\n    background: #75787B;\n  }\n  * {\n    scrollbar-color: #3A3A38 #1A1A1A;\n    scrollbar-width: thin;\n  }\n}\n\nhtml.dark-mode ::-webkit-scrollbar {\n  width: 8px;\n  height: 8px;\n}\nhtml.dark-mode ::-webkit-scrollbar-track {\n  background: #1A1A1A;\n}\nhtml.dark-mode ::-webkit-scrollbar-thumb {\n  background: #3A3A38;\n  border-radius: 4px;\n}\nhtml.dark-mode ::-webkit-scrollbar-thumb:hover {\n  background: #75787B;\n}\nhtml.dark-mode * {\n  scrollbar-color: #3A3A38 #1A1A1A;\n  scrollbar-width: thin;\n}\n\n/* ── Global cursor reset ─────────────────────────────────────────────────────\n   !important is required here because emotion injects styled-component class\n   rules AFTER this static file loads, and equal-or-higher specificity class\n   rules would otherwise override * without !important. */\n* {\n  cursor: default !important;\n}\n\na,\nbutton,\nselect,\nlabel,\nsummary,\n[role=\"button\"],\n[role=\"tab\"],\n[role=\"menuitem\"],\n[role=\"option\"],\n[role=\"checkbox\"],\n[role=\"radio\"],\n[role=\"switch\"] {\n  cursor: pointer !important;\n}\n\ninput,\ntextarea,\n[contenteditable=\"true\"] {\n  cursor: text !important;\n}\n\n/* cursor: not-allowed on disabled interactive elements */\n:disabled,\n[aria-disabled=\"true\"] {\n  cursor: not-allowed !important;\n}\n\n.ProseMirror[contenteditable=\"false\"] {\n  cursor: default !important;\n  user-select: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
